import './about.css';
import { useEffect, useRef } from 'react';

export const Fibonacci = () => {
  const canvasRef = useRef();

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    let frame;

    const fib = [1, 1];

    while (fib.length < 144) {
      fib.push(fib[fib.length - 1] + fib[fib.length - 2]);
    }

    const resize = () => {
      canvas.width = canvas.clientWidth;
      canvas.height = canvas.clientHeight;
    };

    resize();
    window.addEventListener('resize', resize);

    function buildSquares() {
      const squares = [];

      squares.push({
        x: 0,
        y: 0,
        size: fib[0],
        dir: 0
      });

      squares.push({
        x: 1,
        y: 0,
        size: fib[1],
        dir: 1
      });

      let minX = 0;
      let minY = 0;
      let maxX = 2;
      let maxY = 1;

      for (let i = 2; i < fib.length; i++) {
        const size = fib[i];
        const dir = i % 4;

        let x;
        let y;

        switch (dir) {
          case 0:
            x = minX;
            y = minY - size;
            minY = y;
            break;

          case 1:
            x = minX - size;
            y = minY;
            minX = x;
            break;

          case 2:
            x = minX;
            y = maxY;
            maxY += size;
            break;

          case 3:
            x = maxX;
            y = minY;
            maxX += size;
            break;
        }

        squares.push({
          x,
          y,
          size,
          dir
        });
      }

      return squares;
    }

    const squares = buildSquares();

    let rotation = 0;

    function draw() {
      rotation += 0.0033;

      ctx.clearRect(
        0,
        0,
        canvas.width,
        canvas.height
      );

      const scale = Math.min(canvas.width, canvas.height) / 21;

      ctx.save();

      ctx.translate(
        canvas.width / 2,
        canvas.height / 2
      );

      ctx.rotate(rotation);

      ctx.scale(
        scale,
        scale
      );

      ctx.translate(-1, -1);

      ctx.strokeStyle = 'rgba(0,0,0,.15)';
      ctx.lineWidth = 2 / scale;

      squares.forEach((sq) => {
        let cx;
        let cy;
        let start;
        let end;

        switch (sq.dir) {
          case 0:
            cx = sq.x;
            cy = sq.y + sq.size;
            start = Math.PI * 1.5;
            end = Math.PI * 2;
            break;

          case 1:
            cx = sq.x + sq.size;
            cy = sq.y + sq.size;
            start = Math.PI;
            end = Math.PI * 1.5;
            break;

          case 2:
            cx = sq.x + sq.size;
            cy = sq.y;
            start = Math.PI * 0.5;
            end = Math.PI;
            break;

          case 3:
            cx = sq.x;
            cy = sq.y;
            start = 0;
            end = Math.PI * 0.5;
            break;
        }

        ctx.beginPath();

        ctx.arc(
          cx,
          cy,
          sq.size,
          start,
          end
        );

        ctx.stroke();
      });

      ctx.restore();

      frame = requestAnimationFrame(draw);
    }

    draw();

    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener('resize', resize);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      className='about-fibonacci'
    />
  );
};